import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ExamManagementService } from 'src/app/Services/exam-management/exam-management.service';
import { ConstantVars } from 'src/app/utils/constants/constants';
import { AnswerChoice, IQuestion } from '../add-edit-mock-exam-question/add-edit-mock-exam-question.component';
import { StudyunitPracticeTestService } from 'src/app/Services/studyunit-practice-test.service';

@Component({
  selector: 'app-add-edit-studyunit-practice-question',
  templateUrl: './add-edit-studyunit-practice-question.component.html',
  styleUrls: ['./add-edit-studyunit-practice-question.component.css']
})
export class AddEditStudyunitPracticeQuestionComponent implements OnInit {
  private destroy$ = new Subject<void>();
  questions: IQuestion[] = [];
  MockExamId: number;
  courseId: number;
  MockExamSequenceNumber: number;
  ExamAgencyName: string;
  CourseName: string;
  ExamYear: string;
  MocKExamSequenceNumber: number;
  subjectId: number;
  totalQuestions: number;
  subjectName: string;
  currentNumberOfQuestions: number;
  questionId: string | null;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ExamService: ExamManagementService,
    private readonly toaster: ToastrService,
    private location: Location,
    private practiceTestService: StudyunitPracticeTestService,
  ) {}

  ngOnInit(): void {
    combineLatest([this.route.queryParams, this.route.params])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([queryParams, params]) => {
        this.courseId = +queryParams['c_id'];
        this.MockExamSequenceNumber = +queryParams['m_Seq'];
        this.ExamAgencyName = queryParams['eA_Name'];
        this.CourseName = queryParams['c_Name'];
        this.ExamYear = queryParams['eY_Name'];
        this.subjectId = +queryParams['s_id'];
        const t_q = queryParams['t_q'];
        this.totalQuestions = t_q != null && t_q !== '' && !isNaN(+t_q) ? +t_q : 0;
        this.subjectName = queryParams['s_name'];
        this.questionId = queryParams['q_id'] ?? null;

        this.MockExamId = +params['id'];

        this.getQuestionsForMockExam(); // ✅ Now called after both params & queryParams are fetched
      });

      this.getStudyUnitPracticeTestQuestions()
  }

  getQuestionsForMockExam() {
    this.getStudyUnitPracticeTestQuestions()
    const request = {
      CourseTestId: this.MockExamId,
      CourseId: this.courseId,
      SubjectID: this.subjectId,
      NumberOfQuestions: this.totalQuestions,
      QuestionID: this.questionId,
    };
    this.practiceTestService.GetQuestionForStudyMaterialPracticeTest(request).subscribe((res) => {
      this.questions = res;
      console.log(this.questions);
      if (this.questionId) {
        this.questions.forEach((question) => {
          question.SelectedQuestion = true;
          question.Answer_Choices.forEach((choice) => {
            choice.selected = choice.Answer_Selected_IND === 'Y';
          });
        });
      }
    });
  }

  onQuestionSelectionChange(item: IQuestion, event:any): void {
    const checked = event.target.checked;
    if(checked){
      this.currentNumberOfQuestions ++
    }
    else{
      this.currentNumberOfQuestions--
    }
    if (!item.SelectedQuestion) {
      // Unselect all choices except for the correct answer
      item.Answer_Choices.forEach((choice: any) => {
        if (choice.Right_Answer_Ind !== 'Y') {
          choice.selected = false;
        }
      });
    } else {

      const numChoices = item.Answer_Choices.length;
      const numToSelect = item.Number_Of_Answer_Choices;
      if (numToSelect < numChoices) {
        this.toaster.warning(
          `You can only select  ${numToSelect} of answers for this question `,
          'Warning',{timeOut:1300}
        );}

      item.Answer_Choices.forEach((choice: any, idx: number) => {
        if (idx < item.Number_Of_Answer_Choices) {
          choice.selected = true;
        } else {
          choice.selected = false;
        }
      });
    }
  }


  onAnswerSelectionChange(
    item: IQuestion,
    choice: AnswerChoice,
    event: Event
  ): void {
    const control = event.target as HTMLInputElement;
    const checked = control.checked;
    if (checked) {
      // If the choice is selected, unselect the question
      if (
        item.Answer_Choices &&
        item.Answer_Choices.filter((choice: any) => choice.selected).length <=
          item.Number_Of_Answer_Choices
      ) {
      } else {
        this.toaster.error(
          'You can not select more than ' +
            item.Number_Of_Answer_Choices +
            ' choices'
        );
        control.checked = false;
        choice.selected = false;
      }
    }
  }

  navigateBack() {
    this.location.back();
  }

  getStudyUnitPracticeTestQuestions() {
    const payload = {
      CourseTestId: this.MockExamId,
      CourseTestStatusTypeCode: null,
    };
    this.practiceTestService.getStudyUnitPracticeTestQuestion(payload).subscribe((res) => {
      console.log(res);
      this.currentNumberOfQuestions = res[0]?.Current_Number_Of_Question ?? 0
    });
  }

  onSave() {
    console.log(this.questions);

    if (this.questions) {
      const invalidQuestion = this.questions
        .filter((question) => question.SelectedQuestion)
        .find(
          (ques) =>
            ques.Answer_Choices.filter((e) => e.selected).length <
            ques.Number_Of_Answer_Choices
        );

      if (invalidQuestion) {
        this.toaster.error(
          `Please select total of ${invalidQuestion.Number_Of_Answer_Choices} Answer choices for question ${invalidQuestion.Question_ID}`,
          '',
          { timeOut: ConstantVars.ToastErrorTimeout }
        );
        return;
      }

      if (this.questions.some((question) => question.SelectedQuestion)) {
        const payload = {
          UDTTestQuestion: this.questions
            .filter((question) => question.SelectedQuestion) // ✅ Only include selected questions
            .map((question) => ({
              CourseTestId: this.MockExamId,
              QuestionId: question.Question_ID,
              QuestionNumber: 0,
              RightAnswerScore: question.RightAnswerDefaultScore ?? 0, // Ensure number type
              WrongAnswerScore: question.WrongAnswerPenaltyDefaultScore ?? 0, // Ensure number type
              TimeToAnswerInSeconds: question.TimeToAnswerInSeconds ?? 0, // Ensure number type
              OptionalQuestionInd:
                question.Optional_Question_Ind === true ? 'Y' : 'N',
              SelectedIND: 'Y', // Since only selected questions are included
            })),

          UDTTestQuestionAnswerChoice: this.questions
            .filter((question) => question.SelectedQuestion) // ✅ Only include selected questions
            .reduce((acc, question) => {
              const choices = question.Answer_Choices.map((choice) => ({
                CourseTestId: this.MockExamId,
                QuestionId: question.Question_ID,
                AnswerChoiceId: choice.Answer_Choice_Id ?? 0, // Ensure number type
                AnswerChoiceSequenceNumber: 0,
                SelectedIND: choice.selected ? 'Y' : 'N',
              }));
              return acc.concat(choices);
            }, [] as any[]),
        };

        this.ExamService.insertOrUpdateTestQuestion(payload).subscribe(
          (res) => {
            console.log(res);
            this.toaster.success('Saved Successfully', 'Success', {
              timeOut: ConstantVars.ToastSucessTimeout,
            });
            this.getQuestionsForMockExam()
            this.getStudyUnitPracticeTestQuestions()
            // this.router.navigate(['exam-management/mock-exam-question'], {
            //   queryParams: {
            //     c_id: this.courseId,
            //     m_Seq: this.MockExamSequenceNumber,
            //     eA_Name: this.ExamAgencyName,
            //     c_Name: this.CourseName,
            //     eY_Name: this.ExamYear,
            //     s_id: this.subjectId,
            //     t_q: this.totalQuestions,
            //     s_name: this.subjectName,
            //     c_q: this.currentNumberOfQuestions,
            //   },
            // });
          },
          (error) => {
            console.log(error);

            this.toaster.error(error.error.Message, '', {
              timeOut: ConstantVars.ToastErrorTimeout,
            });
          }
        );
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    const fullUrl = this.router.url;

    // If the current URL does NOT include 'Exam/StudyMaterial', clear the selection
    if (!fullUrl.includes('Exam/StudyUnit')) {
      this.practiceTestService.setSelectedPracticeTestId(null);
    }
  }
}
